import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  DamageDefinitionDetailDto,
  DamageDefinitionPicklistOptionDto,
} from "src/store/contract-damage-definition/type";
import {
  deleteDamageDefinitionPicklistOption,
  getDamageDefinitionDetails,
  getDamageDefinitionPicklistOptionDetail,
  getPicklistOptionsDamageDefinitionId,
} from "src/store/contract-damage-definition/saga";
import DamageOptionCreateForm from "./create";
import DamageOptionEditForm from "./edit";

const DamageOptionsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<DamageDefinitionPicklistOptionDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<DamageDefinitionPicklistOptionDto>();
  const [feature, setFeature] = useState<DamageDefinitionDetailDto>();
  const columns = [
    {
      text: t("Contract.DamageOption.Definition"),
      dataField: "DamageDefinitionName",
    },
    {
      text: t("Contract.DamageOption.OptionName"),
      dataField: "PicklistOptionName",
    },
  ];
  useEffect(() => {
    dispatch(
      getDamageDefinitionDetails({
        payload: {
          onSuccess: (m, p) => setFeature(p),
          onError: () => {},
        },
        id: id,
      })
    );
  }, [dispatch, id]);
  return (
    <React.Fragment>
      {feature && (
        <>
          <MainPage
            title={t("Contract.DamageOption.PageTitle", { name: feature.Name })}
            metaTag={t("Contract.DamageOption.MetaTag", { name: feature.Name })}
            gridProps={{
              addTitle: t("Contract.DamageOption.AddButton").toString(),
              listData: data,
              columns: columns,
              setDataList: setData,
              paramsid: id,
              action: getPicklistOptionsDamageDefinitionId,
              onCreateClick: () => setShowCreate(true),
              editButton: {
                onClick: (id, data) => {
                  dispatch(
                    getDamageDefinitionPicklistOptionDetail({
                      payload: {
                        onSuccess: (message, payload, response) => {
                          let currenctObject = payload;
                          currenctObject.Translates = response.Translates;
                          setSelected(currenctObject);
                          return setShowEdit(true);
                        },
                        onError: () => {},
                      },
                      id: id,
                    })
                  );
                },
              },
              deleteButton: {
                text: (id, data: DamageDefinitionPicklistOptionDto) =>
                  t("Contract.DamageOption.DeleteQA", {
                    name: data.PicklistOptionName,
                  }),
                action: deleteDamageDefinitionPicklistOption,
                onClick: (id, data) => setShowEdit(data),
              },
            }}
          />
          <DamageOptionCreateForm
            open={showCreate}
            definition={feature}
            onHide={() => setShowCreate(false)}
            onSuccessClick={(m) =>
              onSuccessClickFormBasicForm({
                dispatch: dispatch,
                message: m,
                action: getPicklistOptionsDamageDefinitionId,
                setDataList: setData,
                id: id,
              })
            }
          />
          {selected && (
            <DamageOptionEditForm
              data={selected}
              open={showEdit}
              onHide={() => {
                setShowEdit(false);
                return setSelected(undefined);
              }}
              onSuccessClick={(m) =>
                onSuccessClickFormBasicForm({
                  dispatch: dispatch,
                  message: m,
                  action: getPicklistOptionsDamageDefinitionId,
                  setDataList: setData,
                  id: id,
                })
              }
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default DamageOptionsPage;
